<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
        </a-card>

        <channelSelecter :isDisabled="!is_new" style="border-bottom:1px solid #eaeaea;" @onChannelCodeChange="handleCodeChange"></channelSelecter>

        <div class="bolck_box">
            <a-card  size="small" title="">
                <a-row>
                    <a-col :span="4">

                    </a-col>
                    <a-col :span="16">
                        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout">
                            <a-form-model-item ref="messageservicecode"  prop="messageservicecode" label="业务类型编码">
                                <a-input v-if="is_vue_task" v-model="record.messageservicecode" @blur=" () => {$refs.messageservicecode.onFieldBlur();}" />
                                <span v-else>{{record.messageservicecode}}</span>
                            </a-form-model-item>
                            <a-form-model-item ref="messageservicename" label="业务类型名称" prop="messageservicename">
                                <a-input v-if="is_vue_task" v-model="record.messageservicename" @blur=" () => {$refs.messageservicename.onFieldBlur();}" />
                                <span v-else>{{record.messageservicename}}</span>
                            </a-form-model-item>
                            <a-form-model-item ref="messagestypecode" label="业务分类" prop="messagestypecode">
                                <messageTypeSelecter v-if="is_vue_task" :showAll="true" :defaultmessagetypecode="record.messagestypecode" :channelcode="record.channelcode" @onmessagestypecodeChange="handleMessagestypecodeChange"></messageTypeSelecter>
                                <span v-else>{{record.messagestypename}}</span>
                            </a-form-model-item>
                            
                            <a-form-model-item  label="策略时长（分钟）">
                                <a-input v-if="is_vue_task" v-model="record.strategytime" />
                                <span v-else>{{record.strategytime}}</span>
                            </a-form-model-item>
                            
                        </a-form-model>
                    </a-col>
                </a-row>

            </a-card>
        </div>



        <a-button v-if="is_vue_task" type="primary" @click="handleOk" :loading="confirmLoading" style="display:block;margin:24px auto;">
            保存
        </a-button>
    </div>

</template>
<script>
import channelSelecter from '../../components/channelSelecter'
import messageTypeSelecter from '../../components/messageTypeSelecter'

const m_title = {
    'add_businesstype':'新增业务类型',
    'detail_businesstype':'查看业务类型',
    'edit_businesstype':'编辑业务类型',
};

export default {
    components:{
        channelSelecter,
        messageTypeSelecter
    },
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                messageservicename:[
                    { required: true, message: '请输入业务类型名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                messageservicecode:[
                    { required: true, message: '请输入业务类型编码', trigger: 'blur' },
                ],
                messagestypecode:[
                    { required: true, message: '请选择业务分类', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                channelcode:'',
                channelname:'',
                messageservicecode:'',//--
                messageservicename:'',//--
                strategytime:'',
                messagestypecode:'',
                messagestypename:''
            }
        };
    },

    methods: {
        handleMessagestypecodeChange(msg){
            if(msg.messagestypecode){
                this.record.messagestypecode = msg.messagestypecode;
                this.record.messagestypename = msg.messagestypename;
            }

        },
        handleCodeChange(item){
            this.record.channelcode = item.value;
            this.record.channelname = item.text;
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.submitData();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        submitData(){
            this.confirmLoading = true;
            const { params } = this.$route;
            if(params.action == 'edit_businesstype'){
                this.$store
                    .dispatch({
                        type: "mcmsmanager/updateMcmsMessageService",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
            else if(params.action == 'add_businesstype'){
                this.record.id = '';
                //新增
                this.$store
                    .dispatch({
                        type: "mcmsmanager/insertMcmsMessageService",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            this.handleCancel();
                        }
                        this.confirmLoading = false;
                    });
            }
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.messageservicecode = 'MSGCODE-000'
        },

        getDetail(id){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/selectMcmsMessageServicesOne",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    
                }
            });
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_businesstype";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_businesstype'

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}


.bolck_box{
    padding: 20px;
}


</style>
